/** Legacy schema_id → canonical "module.type" mapping.
 *  Backend still stores some entities with old underscore/flat IDs. */
const LEGACY_SCHEMA_MAP: Readonly<Record<string, string>> = {
  person: "contacts.person",
  email_message: "email.message",
  email_address: "email.address",
  telegram_message: "telegram.message",
  telegram_chat: "telegram.chat",
  calendar_event: "meetings.calendar_event",
  file_object: "file.object",
};

export function normalizeSchemaId(schemaId: string): string {
  return LEGACY_SCHEMA_MAP[schemaId] ?? schemaId;
}

export function entityHref(
  schemaId: string,
  entityId: string | null | undefined,
): string | null {
  if (!schemaId || !entityId) return null;
  const normalized = normalizeSchemaId(schemaId);
  if (!normalized.includes(".")) return null;
  return `#/${normalized.replace(".", "/")}/${entityId}`;
}
